import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RefreshCw } from "lucide-react";

export const UpdateAvailable = () => {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker.getRegistration().then((reg) => {
      if (!reg) return;

      // If there's already a waiting worker
      if (reg.waiting) setWaiting(reg.waiting);

      // Listen for new installations
      reg.addEventListener("updatefound", () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            setWaiting(newWorker);
          }
        });
      });
    });

    // Reload page when new SW takes control
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }, []);

  const handleUpdate = () => {
    if (!waiting) return;
    waiting.postMessage({ type: "SKIP_WAITING" });
  };

  return (
    <AnimatePresence>
      {waiting && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-20 left-3 right-3 z-50 bg-[#7000FF] text-white rounded-3xl p-4 shadow-2xl flex items-center gap-3 md:left-auto md:right-4 md:max-w-sm"
          data-testid="update-available"
        >
          <RefreshCw className="w-5 h-5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-bold text-sm">Nouvelle version disponible</p>
            <p className="text-[11px] opacity-80">Recharge pour profiter des dernieres ameliorations.</p>
          </div>
          <button
            onClick={handleUpdate}
            className="bg-white text-[#7000FF] font-bold px-3 py-1.5 rounded-full text-xs hover:scale-105 active:scale-95 transition-transform"
            data-testid="update-app-btn"
          >
            Recharger
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
